// Utility function to get GA4 client_id from _ga cookie
export default function getGA4ClientId(): string | null {
  const cookies = document.cookie;
  const gaCookie = cookies.match(/(?:^|;\s*)_ga=([^;]*)/);

  if (!gaCookie) {
    return null;
  }

  const gaCookieValue = decodeURIComponent(gaCookie[1]);

  // Parse the _ga cookie format: GA1.{domain_depth}.{client_id}
  const parts = gaCookieValue.split('.');

  if (parts.length >= 4 && parts[0] === 'GA1') {
    // The client_id consists of the last two parts joined by a dot
    return `${parts[2]}.${parts[3]}`;
  }

  return null;
}
